import { render, staticRenderFns } from "./msgList.vue?vue&type=template&id=2ddf9534&scoped=true&"
import script from "./msgList.vue?vue&type=script&lang=js&"
export * from "./msgList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddf9534",
  null
  
)

export default component.exports